import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MobileView } from 'react-device-detect';
import { ShowExplorerTabContent, ShowExplorerTabBox } from './styled/StyledExplorer';
import { setShowExplorer } from '../../../actions/LayoutActions';

const ShowExplorerTab = () => {
  const dispatch = useDispatch();
  const showExplorer = useSelector((state) => state.layout.showExplorer);

  return (
    <MobileView>
      <ShowExplorerTabBox className={showExplorer ? 'show-explorer' : ''} onClick={() => dispatch(setShowExplorer(!showExplorer))}>
        <ShowExplorerTabContent>----</ShowExplorerTabContent>
      </ShowExplorerTabBox>
    </MobileView>
  );
};

export default ShowExplorerTab;
